import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { Auth0Provider } from '@auth0/auth0-react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      networkMode: 'offlineFirst',
      staleTime: 60 * 1000 * 10,
      refetchInterval: 60 * 1000 * 10,
    },
    mutations: {
      networkMode: 'offlineFirst',
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <Auth0Provider
    domain="https://dev-o1qrf5xyjvehcnkq.us.auth0.com"
    clientId="AVUDOzOKA2Q5n0bqzOZTz35F1kBjFt0t"
    authorizationParams={{
      redirect_uri: window.location.origin,
      scope: 'openid profile email',
      audience: 'https://default.yourwayhome/',
    }}
    cacheLocation="localstorage"
    useRefreshTokens={true}
  >
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </Auth0Provider>,
);
